/**
 * Unregisters tool in the document viewer tool mode map, and removes the button object.
 * @method UI.unregisterTool
 * @param {string} toolName Name of the tool, either from <a href='https://docs.apryse.com/documentation/web/guides/annotations-and-tools/#list-of-tool-names' target='_blank'>tool names list</a> or the name you registered your custom tool with.
 * @example
WebViewer(...)
  .then(function(instance) {
    instance.UI.unregisterTool('MyTool');
  });
 */

import core from 'core';
import actions from 'actions';

export default (store) => (toolName) => {
  unregisterToolInRedux(store, toolName);
  unregisterToolInToolModeMap(toolName);
};

const unregisterToolInRedux = (store, toolName) => {
  store.dispatch(actions.unregisterTool(toolName));
};

const unregisterToolInToolModeMap = (toolName) => {
  core.getDocumentViewers().forEach((viewer) => {
    delete viewer.getToolModeMap()[toolName];
  });
};